import { render, staticRenderFns } from "./specificProjectDeviceList.vue?vue&type=template&id=2fe0deff&scoped=true"
import script from "./specificProjectDeviceList.vue?vue&type=script&lang=js"
export * from "./specificProjectDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0deff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe0deff')) {
      api.createRecord('2fe0deff', component.options)
    } else {
      api.reload('2fe0deff', component.options)
    }
    module.hot.accept("./specificProjectDeviceList.vue?vue&type=template&id=2fe0deff&scoped=true", function () {
      api.rerender('2fe0deff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/taskList/components/specificProjectDeviceList.vue"
export default component.exports